import {Car, Phone, Mail, MapPin, Facebook, Instagram, Linkedin} from 'lucide-react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-black text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Car className="w-8 h-8 text-[#fbbf24]" />
              <span className="text-2xl font-bold">Ady Garage</span>
            </div>
            <p className="text-gray-400 text-sm">
              Location de véhicules professionnelle à Bussigny. Qualité, fiabilité et service client exceptionnel.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=100028388966513"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#dc2626] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/garage_carrosserie_ady"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#dc2626] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/in/garage-carrosseries-ady-790918b6"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#dc2626] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Navigation</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/" className="hover:text-[#fbbf24] transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/flotte" className="hover:text-[#fbbf24] transition-colors">
                  Location
                </Link>
              </li>
              <li>
                <a href="https://app.adysarl.ch/" target="_blank" rel="noopener noreferrer" className="hover:text-[#fbbf24] transition-colors">
                  Fidélité
                </a>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#fbbf24] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Informations légales */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Informations</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/conditions" className="hover:text-[#dc2626] transition-colors">
                  Conditions générales
                </Link>
              </li>
              <li>
                <Link to="/assurance" className="hover:text-[#dc2626] transition-colors">
                  Assurance
                </Link>
              </li>
              <li>
                <Link to="/confidentialite" className="hover:text-[#dc2626] transition-colors">
                  Confidentialité
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="hover:text-[#dc2626] transition-colors">
                  Mentions légales
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#fbbf24]" />
                <a href="tel:+41217062626" className="hover:text-[#fbbf24] transition-colors">
                  021 706 26 26
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#fbbf24]" />
                <a href="mailto:info@adysarl.ch" className="hover:text-[#fbbf24] transition-colors">
                  info@adysarl.ch
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-[#fbbf24] mt-1" />
                <span>Rue de l'Industrie 49, 1030 Bussigny</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} Ady Garage. Tous droits réservés. — Créé par la <a href="https://ruche-digitale.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#fbbf24] transition-colors">Ruche digitale</a></p>
        </div>
      </div>
    </footer>
  )
}
